export const SSO_TYPE_SAML = "saml"
export const SSO_TYPE_NONE = "none"
export const SAML_REQUEST_TYPE_POST = "POST"
export const SAML_REQUEST_TYPE_REDIRECT = "REDIRECT"
export const SAML_REQUEST_TYPES = [SAML_REQUEST_TYPE_POST, SAML_REQUEST_TYPE_REDIRECT]

export const RESOLVED_SAML_REQUEST_TYPES_KEY = [
  {label: "admin.components.samlSingleSignOn.signUpOptions.requestType.post", value: SAML_REQUEST_TYPE_POST},
  {label: "admin.components.samlSingleSignOn.signUpOptions.requestType.redirect", value: SAML_REQUEST_TYPE_REDIRECT}
]
